import { FC } from 'react'

import { Grid, Skeleton, Stack, Table } from '@forto-dev/phoenix-ui-core'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Back } from '@/fragments/back'
import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { WidgetSkeleton } from '@/fragments/widgetSkeleton'
import { useLocalisation } from '@/utils/localisation'

import { ShipmentDetailTitleSkeleton } from './detailsSkeleton'

const ShipmentCustomsMainSkeleton: FC = () => {
  const { translate } = useLocalisation()
  return (
    <Stack gap={24}>
      <Skeleton variant="content" size={24} fullWidth />
      <Grid col={5}>
        <Skeleton variant="badge" />
      </Grid>
      <Table
        columns={[
          {
            id: 'index',
            header: translate('details.customs.table.index'),
            cell: () => <Skeleton variant="content" />,
            accessorKey: '',
          },
          {
            id: 'containerId',
            header: translate('details.customs.table.id'),
            cell: () => <Skeleton variant="content" />,
            accessorKey: '',
          },
          {
            id: 'type',
            header: translate('details.customs.table.type'),
            cell: () => <Skeleton variant="content" />,
            accessorKey: '',
          },
          {
            id: 'commodity',
            header: translate('details.customs.table.commodity'),
            cell: () => <Skeleton variant="content" />,
            accessorKey: '',
          },
          {
            id: 'update',
            header: translate('details.customs.table.update'),
            cell: () => <Skeleton variant="content" />,
            accessorKey: '',
          },
          {
            id: 'status',
            header: translate('details.customs.table.status'),
            cell: () => <Skeleton variant="content" />,
            accessorKey: '',
          },
          {
            id: 'update',
            header: translate('details.customs.table.update'),
            cell: () => <Skeleton variant="content" />,
            accessorKey: '',
          },
        ]}
        data={[{}]}
        footless
      />
    </Stack>
  )
}

export const CustomsSkeleton: FC = () => {
  return (
    <Layout
      header={<Header />}
      title={<ShipmentDetailTitleSkeleton />}
      hideTitleBackgroundImage
      sidebar={<WidgetSkeleton count={3} />}
      navigation={<Back to="/" />}
      main={<ShipmentCustomsMainSkeleton />}
      footer={<Footer />}
    />
  )
}
